import * as React from 'react';
import { FC } from 'react';
import * as Sentry from '@sentry/browser';
import { containerStyles } from '../../layout/styles';
import InvoicingListView from './InvoicingListView';
import { InvoiceSubmission } from './types';
import SubmitInvoice from './SubmitInvoice';
import InvoiceDetailView from './InvoiceDetailView';

type InvoicingView = 'list' | 'submit' | 'detail';

const InvoicingWindow: FC = () => {
  const [view, setView] = React.useState<InvoicingView>('list');
  const [selectedInvoice, setSelectedInvoice] = React.useState<InvoiceSubmission | null>(null);

  // Once per mount: session-level classification + active-feature attribution
  React.useEffect(() => {
    Sentry.setTag('visited_invoicing', 'true'); // sticky — intentionally NOT cleaned up
    Sentry.setTag('feature', 'invoicing');
    return () => {
      Sentry.setTag('feature', undefined);
      Sentry.setTag('invoicing_view', undefined);
    };
  }, []);

  // On every internal view change: sub-view attribution + replay timeline marker
  React.useEffect(() => {
    Sentry.setTag('invoicing_view', view);
    Sentry.addBreadcrumb({ category: 'navigation', message: `Invoicing → ${view}`, level: 'info' });
  }, [view]);

  if (view === 'submit') {
    return (
      <div className={containerStyles.container}>
        <div className={containerStyles.containerInner}>
          <SubmitInvoice onBack={() => setView('list')} onSubmit={() => setView('list')} />
        </div>
      </div>
    );
  }

  if (view === 'detail' && selectedInvoice) {
    return (
      <div className={containerStyles.container}>
        <div className={containerStyles.containerInner}>
          <InvoiceDetailView invoice={selectedInvoice} onBack={() => setView('list')} />
        </div>
      </div>
    );
  }

  return (
    <InvoicingListView
      onSubmitInvoice={() => setView('submit')}
      onInvoiceClick={(invoice) => {
        setSelectedInvoice(invoice);
        setView('detail');
      }}
    />
  );
};

export default InvoicingWindow;
